var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrathful(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#848484",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.419,
    y: 14.788,
    transform: "matrix(0.3042 -0.9526 0.9526 0.3042 -5.9433 33.4386)",
    width: 11,
    height: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.76,26.147L8.456,27.1c0,0.001,0,0.001,0,0.001l16.194,5.171c0.526,0.168,1.089-0.122,1.257-0.648v0  c0.168-0.526-0.122-1.089-0.648-1.257l-15.241-4.868C9.49,25.331,8.928,25.621,8.76,26.147z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.188,9.304c-0.526-0.168-1.089,0.122-1.257,0.648v0c-0.168,0.526,0.122,1.089,0.648,1.257l15.242,4.868  c0.526,0.168,1.089-0.122,1.257-0.648v0c0.168-0.526-0.122-1.089-0.648-1.257L15.188,9.304z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.928,33.565c0.251-0.788-0.185-1.634-0.973-1.885c0-0.001,0-0.001,0-0.001l-30.959-9.887l-0.913,2.857l30.959,9.888  C58.834,34.789,59.677,34.353,59.928,33.565z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31,57c0.552,0,1-0.447,1-1v-6c0-0.553-0.448-1-1-1h-3.101c-0.463-2.282-2.48-4-4.899-4H11c-2.419,0-4.436,1.718-4.899,4H3  c-0.552,0-1,0.447-1,1v6c0,0.553,0.448,1,1,1H31z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrathful);
export default __webpack_public_path__ + "static/media/wrathful.0dcdee5de2b56f9646b8dea111d49fd5.svg";
export { ForwardRef as ReactComponent };